import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { Field } from 'formik';

import { renderField } from '../../../../../core/utils/formik';
import { mapSelectOptions } from '../../test-form-utils';

import SelfCleaningField from './SelfCleaningField';

const propTypes = {
  index: PropTypes.number.isRequired,
  schema: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired,
};

class ILDeviceFields extends Component {
  constructor(props) {
    super(props);

    this.validateLocation = this.validateLocation.bind(this);
    this.validateLocationOther = this.validateLocationOther.bind(this);
  }

  validateLocation(value) {
    if (!value) { return 'Required'; }
    return undefined;
  }

  validateLocationOther(value) {
    const { location } = this.props.device;
    if (location && (location === 'O') && !value) { return 'Required'; }
    return undefined;
  }

  render() {
    const { index, schema, device } = this.props;
    const locationTitle = schema.getIn(['location', 'title']);
    const options = mapSelectOptions(schema.get('location'));

    return (
      <React.Fragment>
        <Col>
          <Field
            type="select"
            name={`test_devices.${index}.location`}
            label={locationTitle}
            component={renderField}
            validate={this.validateLocation}
            required
          >
            <option />
            {options.map(([key, value]) => <option key={value} value={value}>{key}</option>)}
          </Field>
        </Col>

        {(device.location === 'O') &&
          <Col>
            <Field
              type="text"
              name={`test_devices.${index}.location_other`}
              label="Description"
              component={SelfCleaningField}
              validate={this.validateLocationOther}
              required={device.location === 'O'}
            />
          </Col>
        }
      </React.Fragment>
    );
  }
}

ILDeviceFields.propTypes = propTypes;

export default ILDeviceFields;



// WEBPACK FOOTER //
// ./src/features/test/TestForm/DeviceStateFields/states/ILDeviceFields.js